import CacheBase2 from '../../services/engines/CacheBase2';
import { CalEventStates } from '../Types/CalEventStates';

const _name = 'CalendarCache';

class CalendarCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }

    /**
     * Returns all upcoming events — everything not Completed or Deleted, sorted ascending by ems.
     * Includes Active, Overdue and Visible events.
     * @returns {CalEventObj[]}
     */
    getUpcoming = () => {
        try {
            this._check();
            return this._items
                .filter((e) => e.stateId !== CalEventStates.Completed && e.stateId !== CalEventStates.Deleted)
                .sort((a, b) => a.ems - b.ems);
        } catch (error) {
            this.logError('getUpcoming', error.message);
            return [];
        }
    };

    /**
     * Returns all events currently flagged Visible — shown as floating cards.
     * Sorted ascending by ems.
     * @returns {CalEventObj[]}
     */
    getVisible = () => {
        try {
            this._check();
            return this._items.filter((e) => e.stateId === CalEventStates.Visible).sort((a, b) => a.ems - b.ems);
        } catch (error) {
            this.logError('getVisible', error.message);
            return [];
        }
    };

    /**
     * Updates the stateId of a single cached event.
     * No-op if rk is not found in cache.
     * @param {string} rk
     * @param {number} stateId - see CalEventStates
     */
    setState = (rk, stateId) => {
        try {
            this._check();
            const item = this._items.find((e) => e.rk === rk);

            if (!item) return;
            item.stateId = stateId;
        } catch (error) {
            this.logError('setState', error.message);
        }
    };
}

const calendarCache = new CalendarCache();
export default calendarCache;
